import { getCurrentThemeType } from '../../common/themes';
import {
  Connection,
  ThemedIcons,
  ThemeType,
  ConnectionType,
} from '../types/connection-types';

export const resolveIcon = (connectionIcons: ThemedIcons) => {
  const currentThemeType = getCurrentThemeType();
  const icon = connectionIcons[currentThemeType];
  if (!icon) {
    return connectionIcons[ThemeType.Dark].iconURL;
  }

  return icon.iconURL;
};

export const resolveSubtitle = (connection: Connection) => {
  const { displayName, connectionType } = connection;
  const suffix = SubtitleSuffix[connectionType] || '';

  return `Allow users to login using ${displayName} ${suffix}`;
};

const SubtitleSuffix: Record<ConnectionType, string> = {
  Auth0UsernamePassword: '',
  Github: 'Identity Provider',
  GoogleOauth2: 'Identity Provider',
  AzureAD: '(SSO)',
  Okta: '(SSO)',
};
